import React, { useState } from "react";
import emailjs from "@emailjs/browser"; // Add this import

const FeedBack = () => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const SERVICE_ID = "service_43svccq";
  const TEMPLATE_ID = "template_7o3na8a";
  const RECEIVER_ID = "template_cmce59y";
  const USER_ID = "yBv-k2iGjO-9IwGVE";

  const templateParams = {
    name: name,
    message: message,
    email: email,
  };

  const handleSubmitEmail = (e) => {
    e.preventDefault();

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID).then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        setName("");
        setMessage("");
        setEmail("");
      },
      (err) => {
        console.log("FAILED...", err);
        alert("Error submitting the form");
      },
    );
  };

  const handleSubmitReceiverEmail = (e) => {
    e.preventDefault();

    emailjs.send(SERVICE_ID, RECEIVER_ID, templateParams, USER_ID).then(
      (response) => {
        console.log("SUCCESS!", response.status, response.text);
        setName("");
        setMessage("");
        setEmail("");
      },
      (err) => {
        console.log("FAILED...", err);
        alert("Error submitting the form");
      },
    );
  };

  const handleSubmitGoogle = (e) => {
    e.preventDefault();

    const formData = new URLSearchParams();
    formData.append("entry.849116195", name);
    formData.append("entry.1645087291", message);
    formData.append("entry.1933628429", email);

    fetch(
      "https://docs.google.com/forms/d/e/1FAIpQLSfbVjH2vqkfFg5DDlgLnaf8O9ioRDyPjptYy3dBUDjc7FoX9g/formResponse",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
        mode: "no-cors",
      },
    )
      .then(() => {
        setIsSubmitted(true);
        setName("");
        setMessage("");
        setEmail("");
        setTimeout(() => setIsSubmitted(false), 3000);
      })
      .catch((error) => {
        console.error("Error:", error);
        alert("Error submitting the form");
      });
  };

  const handleSubmit = (e) => {
    // You can choose either handleSubmitEmail or handleSubmitGoogle
    handleSubmitEmail(e);
    handleSubmitReceiverEmail(e);
    handleSubmitGoogle(e);
  };

  return (
    <div className=" bg-[#1e293b] rounded-xl lg:grid lg:grid-cols-2 block lg:justify-between text-white py-12 px-6 w-full">
      <div className="flex flex-col justify-between mt-8">
        <div>
          <h2 className="text-3xl font-bold text-center mb-6 orbitron">
            Send Feedback
          </h2>
          <p className="italic mt-4 philosopher-6">
            "Feel free to share your message, feedback, or inquiries. I will get
            back to you as soon as possible!""
          </p>
          <p className="italic mt-4 philosopher-6">
            "Your feedback is the stepping stone to improvement. Let your voice
            be heard!"
          </p>
        </div>
        <div>
          <img src="/assets/foot.png" alt="foot" />
        </div>
      </div>

      <div className="lg:pl-20 flex justify-center w-full">
        <form onSubmit={handleSubmit} className="w-full">
          <div className="mb-4 w-full">
            <label
              htmlFor="entry.849116195"
              className="block text-xl font-semibold philosopher-6"
            >
              Name
            </label>
            <input
              type="text"
              name="entry.849116195"
              id="entry.849116195"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 border border-gray-600 text-white philosopher-6"
              required
            />
          </div>

          <div className="mb-4">
            <label
              htmlFor="entry.1645087291"
              className="block text-xl font-semibold philosopher-6"
            >
              Message
            </label>
            <textarea
              name="entry.1645087291"
              id="entry.1645087291"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 border border-gray-600 text-white philosopher-6"
              rows="4"
              required
            ></textarea>
          </div>

          <div className="mb-4">
            <label
              htmlFor="entry.1933628429"
              className="block text-xl font-semibold philosopher-6"
            >
              Email
            </label>
            <input
              type="email"
              name="entry.1933628429"
              id="entry.1933628429"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 rounded-md bg-gray-800 border border-gray-600 text-white philosopher-6"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full p-3 bg-[#37508a] rounded-md text-white hover:bg-gray-600 philosopher-6"
          >
            Submit
          </button>
        </form>
      </div>

      {isSubmitted && alert("Submitted successfully!")}
    </div>
  );
};

export default FeedBack;
